import { get } from '../../../utils/get';
export function getPageUrl(item) {
    return get(item, 'category.canonicalUrl');
}
